/*eslint-disable*/
import Vue from 'vue'
import VueRouter from 'vue-router'
const { isNavigationFailure, NavigationFailureType } = VueRouter
import authRoutes from './routes/auth'
import errorsRoutes from './routes/errors'
import dashboardRoutes from './routes/dashboard'
import userRoutes from './routes/user'
import courseRoutes from './routes/course'
import sidebarRoutes from './routes/sidebar'
import trainerRoutes from './routes/trainer'
import olympiadsRoutes from './routes/olympiads'
import toolsRoutes from './routes/tools'
import tariffsRoutes from './routes/tariffs'
import battleRoutes from './routes/battles'
import billingRoutes from './routes/billing'
import bonusesRoutes from './routes/bonuses'
import homeworkRoutes from './routes/homeworks'
import schoolRoutes from './routes/school'
import gradesRoutes from './routes/grade'
import templatesRoutes from './routes/templates'
import gamesRoutes from './routes/games'
import counter from '../app/Counter'
import Cookies from 'js-cookie';
import * as cookies from '../config/cookies'
import store from '../store';
import {
    ROUTES_UNDER_PLAY_TIME_RESTRICTION,
    TEMPLATE_ROUTES_HIDDEN_FOR_FREE_TARIFF_TEACHER,
} from '@/config/tariff_constants';
import { checkUserRouteAccess, isFreeTariffTeacher } from '@/utils/tariffHelper';

Vue.use(VueRouter);

const routesWithDefaultLayout = sidebarRoutes.concat(
    gamesRoutes, trainerRoutes, userRoutes, olympiadsRoutes,
    battleRoutes, dashboardRoutes, toolsRoutes, templatesRoutes,
    homeworkRoutes, schoolRoutes, gradesRoutes, courseRoutes,
    billingRoutes, bonusesRoutes, tariffsRoutes,
);

const routes = [
    {
        path: '/:lang?/auth',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "auth" */'../layouts/auth/Layout.vue'),
        children: authRoutes
    },
    {
        path: '/',
        component: () => import('../layouts/default/Layout.vue'),
        children: routesWithDefaultLayout,
        beforeEnter: (to, from, next) =>  {
            const token = Cookies.get(cookies.USER_TOKEN);
            if (token) {
                const user = store.state.auth.user;
                user
                    ? next()
                    : store.dispatch('setUserToken', token).then(() => next());
            } else {
                next({name: 'login'})
            }
        }
    },
    {
        path: '/error',
        component: () => import(/* webpackPrefetch: true */'../layouts/errors/Layout.vue'),
        children: errorsRoutes,
    }
];

let router = new VueRouter({
    routes,
    mode: 'history',
    linkActiveClass: 'is-open',
    linkExactActiveClass: 'is-active',
    scrollBehavior (to, from, savedPosition) {
        if (!savedPosition) {
            return { x: 0, y: 0 };
        }
        if (to.name.includes('list')) {
            to.params.savedHeightPosition = savedPosition.y;
            return { x: 0, y: 0 };
        }
        return { x: 0, y: savedPosition.y, behavior: 'smooth'};
    }
});

function patchRouterMethod (router, methodName) {
    router['old' + methodName] = router[methodName];
    router[methodName] = async function (location) {
        return router['old' + methodName](location).catch((error) => {
            if (isNavigationFailure(error, NavigationFailureType.redirected)) {
                return;
            }
            if (isNavigationFailure(error, NavigationFailureType.cancelled)) {
                return;
            }
            if (isNavigationFailure(error, NavigationFailureType.duplicated)) {
                return this.currentRoute;
            }
            throw error;
        });
    }
}
patchRouterMethod(router, 'push');
patchRouterMethod(router, 'replace');

if (!env.offline) {
    router.afterEach((to) => {
        counter.sendPage(to);
    })
}

if (env.offline) {
    router.beforeEach((to, from, next) => {
        if (!(to.path.startsWith('/trainer/game') || to.path.startsWith('/game'))) {
            router.push({name: 'trainer:games'});
            return;
        }
        next();
    })
}

router.beforeEach((to, from, next) => {
    const homework = store.state.trainer.homework;
    const olympiad = store.state.olympiad.olympiad;
    if (!ROUTES_UNDER_PLAY_TIME_RESTRICTION.includes(to.name) || !!homework || !!olympiad) return next();

    const user = store.state.auth.user;

    const { hasLimitTariff, noPlaytimeLeft, adminCantAccess } = checkUserRouteAccess(user, to.name);

    if (hasLimitTariff && noPlaytimeLeft && to.name !== 'user:playtime-ended') {
        return next({ name: 'user:playtime-ended' });
    }

    if (adminCantAccess) {
        return next({ name: '403' });
    }

    next();
});

router.beforeEach((to, from, next) => {
    if (!TEMPLATE_ROUTES_HIDDEN_FOR_FREE_TARIFF_TEACHER.includes(to.name)) return next();

    const user = store.state.auth.user;
    if (isFreeTariffTeacher(user)) {
        return next({ name: 'dashboard' });
    }

    next();
});

const COURSE_ROUTES = ['course:list', 'course:create', 'course:profile', 'course:edit'];

router.beforeEach((to, from, next) => {
    if (!COURSE_ROUTES.includes(to.name)) return next();

    const user = store.state.auth.user;
    if (!user || (!user.isSuperadmin && !user.isManagerOrSupport)) {
        return next({ name: '403' });
    }

    next();
});

export default router;
